
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';

const TestimonialsSection = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: { 
        staggerChildren: 0.2
      }
    }
  };
  
  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { 
      y: 0, 
      opacity: 1,
      transition: {
        duration: 0.5
      }
    }
  };

  const testimonials = [
    {
      name: "Sarah Mueller",
      role: "Studioinhaberin, Beauty Lounge",
      image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=256&q=80",
      quote: "CHRONA hat unsere Terminverwaltung komplett revolutioniert. Wir sparen täglich Stunden an administrativer Arbeit und haben 30% mehr Neukunden durch die Online-Buchungsmöglichkeit."
    },
    {
      name: "Marco Schneider",
      role: "Friseurmeister, Haarscharf",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=256&q=80",
      quote: "Seit wir CHRONA nutzen, haben wir praktisch keine No-Shows mehr. Das automatische Erinnerungssystem ist fantastisch, und die Kunden lieben die einfache Buchungsplattform."
    },
    {
      name: "Jana Meier",
      role: "Kunde",
      image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=256&q=80",
      quote: "Endlich eine Buchungs-App, die einfach funktioniert! Ich bin begeistert, wie schnell ich Termine bei meinen Lieblingssalons buchen kann. Die Erinnerungen sind super praktisch."
    }
  ];

  const renderStars = () => {
    return (
      <div className="flex gap-1">
        {[...Array(5)].map((_, i) => (
          <Star key={i} className="h-5 w-5 fill-[#2C6E49] text-[#2C6E49]" />
        ))}
      </div>
    );
  };

  return (
    <section className="py-24 bg-gradient-to-b from-[#191919] to-[#161616]">
      <div className="container mx-auto px-6">
        <motion.div 
          className="text-center mb-16"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={containerVariants}
        >
          <motion.h2 variants={itemVariants} className="text-3xl md:text-4xl font-bold mb-4 text-[#F8F8F8]">
            Was unsere Kunden sagen
          </motion.h2>
          <motion.p variants={itemVariants} className="text-xl text-[#F8F8F8]/80 max-w-2xl mx-auto">
            Erfahrungen von Studios und Kunden, die CHRONA täglich nutzen
          </motion.p>
        </motion.div>

        <motion.div 
          className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={containerVariants}
        >
          {testimonials.map((testimonial, index) => (
            <motion.div 
              key={testimonial.name}
              className="p-6 bg-[#151515]/70 backdrop-blur-md border border-[#F8F8F8]/10 rounded-[24px] shadow-lg transition-all duration-300 hover:shadow-xl"
              variants={itemVariants}
              whileHover={{ y: -5 }}
            >
              <div className="mb-4">
                {renderStars()}
              </div>
              <p className="text-[#F8F8F8]/90 mb-6 italic">"{testimonial.quote}"</p>
              <div className="flex items-center">
                <img 
                  src={testimonial.image} 
                  alt={testimonial.name} 
                  className="w-12 h-12 rounded-full object-cover mr-4 border-2 border-[#2C6E49]" 
                />
                <div>
                  <h4 className="font-bold text-[#F8F8F8]">{testimonial.name}</h4>
                  <p className="text-sm text-[#F8F8F8]/70">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
        
        <motion.div 
          className="mt-16 text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3, duration: 0.5 }}
        >
          <a href="#" className="text-[#2C6E49] hover:text-[#4C956C] font-medium inline-flex items-center">
            Alle Bewertungen ansehen
            <svg className="w-4 h-4 ml-2" viewBox="0 0 24 24" fill="none">
              <path d="M9 6L15 12L9 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
